<template>
    <sections>
        <section-tiles
            heading="Events Calendar"
            content="<p>Join me at one of these fabulous West Coast Swing events.</p>"
            :tiles="
                events.map((event) => {
                    return {
                        url: event.website,
                        heading: event.name,
                        excerpt:
                            (event.state ? event.state + ' - ' : '') + event.date.toLocaleDateString('en-GB', options),
                    };
                })
            "
        ></section-tiles>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    image: $config.public.images + 'events-calendar.jpg',
    title: 'Events Calendar | ' + $config.public.siteName,
    description: "Lauren's upcoming West Coast Swing events.",
    index: true,
});

const options = ref({
    weekday: undefined,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
});

const store = useEventsStore();

const getEvents = store.getEvents;

const events = getEvents({isUpcoming: true});
</script>
